import { Injectable } from '@angular/core';
import {ServerService} from "../../services/ServerService";
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InstagramDirectService extends ServerService {

  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * Obtém URL de autorização para Instagram Basic Display API
   */
  obtenhaUrlAutorizacao() {
    return this.obtenha('/instagram-direct/urlAutorizacao', {});
  }

  /**
   * Conecta conta Instagram usando código de autorização
   */
  conectar(codigo: string) {
    return this.facaPost('/instagram-direct/conectar', { codigo });
  }

  /**
   * Verifica se há conta Instagram Direct conectada
   */
  obtenhaContaConectada() {
    return this.obtenha('/instagram-direct/contaConectada', {});
  }

  /**
   * Desconecta conta Instagram Direct
   */
  desconectar() {
    return this.facaPost('/instagram-direct/desconectar', {});
  }

  /**
   * Renova token de acesso
   */
  renovarToken() {
    return this.facaPost('/instagram-direct/renovarToken', {});
  }

  /**
   * Obtém dados do perfil conectado
   */
  obtenhaPerfilConectado() {
    return this.obtenha('/instagram-direct/perfil', {});
  }

  /**
   * Obtém mídia do usuário
   */
  obtenhaMidiaUsuario(limit: number = 25) {
    return this.obtenha('/instagram-direct/midia', { limit: limit.toString() });
  }

  /**
   * Testa conexão com Instagram
   */
  testarConexao() {
    return this.obtenha('/instagram-direct/testarConexao', {});
  }
}
